$(document).ready(function () {
    $(".prix.ipt").on('keyup', function (e) {
        var spaced = $(this).val().toString().replace(/\s/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        $(this).val(spaced);
    });
});